import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Button, Glyphicon } from 'react-bootstrap';
import moment from 'moment';

class CalendarWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            date: this.props.date,
            showDatePicker: false
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (newProps) => {
        this.setState({
            date: newProps.date
        });
    }

    // EVENT HANDLERS

    handleBlur (blurEvent) {
        let newDate = moment(blurEvent.target.value.trim(), "YYYY-MM-DD");
        this.props.setDate(newDate);
        this.setState({
            date: newDate,
            showDatePicker: false
        });
    }

    handleChange = (changeEvent) => {
        let newDate = moment(changeEvent.target.value.trim(), "YYYY-MM-DD");
        this.props.setDate(newDate);
        this.setState({
            date: newDate
        });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter") {
            let newDate = moment(ReactDOM.findDOMNode(this.refs.datepicker).children[0].value.trim(), "YYYY-MM-DD");
            this.props.setDate(newDate);
            this.setState({
                showDatePicker: false,
                date: newDate
            });
        }
    }

    // OTHER METHODS

    showDatePicker = () => {
        this.setState({
            showDatePicker: true
        });
    }

    // RENDER METHOD

    render = () => {
        let formattedDate = this.state.date ? this.state.date.format("DD-MM-YYYY") : "Undefined";
        if (formattedDate === "Invalid date") {
            formattedDate = "Undefined";
        }

        // append "Today: " prefix to the text if it is really today
        if (moment().format("DD-MM-YYYY") === formattedDate) {
            formattedDate = "Today: " + formattedDate;
        }

        if (this.state.showDatePicker) {
            return (
                <span>
                    <Button style={this.props.error ? {borderColor : "red"} : {}}className={this.props.pullLeft ? "" : "center-block"}  onClick={this.showDatePicker}>
                        <div className="clearfix">
                            <Glyphicon className="pull-left" glyph="calendar"/>
                            <span className="pull-right"><Input ref="datepicker" type="date" defaultValue={this.state.date ? this.state.date.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")} onKeyPress={this.handleKeyPress} onChange={this.handleChange} onBlur={this.handleBlur}/></span>
                        </div>
                    </Button>
                </span>
            );
        } else {
            return (
                <span>
                    <Button style={this.props.error ? {borderColor : "red"} : {}} className={this.props.pullLeft ? "" : "center-block"} onClick={this.showDatePicker}>
                        <div className="clearfix">
                            <Glyphicon className="pull-left" glyph="calendar"/>
                            <span className="pull-right">&nbsp;&nbsp;<b>{formattedDate}</b></span>
                        </div>
                    </Button>
                </span>
            );
        }
    }
}

CalendarWidget.propTypes = {
    setDate: PropTypes.func,
    date: PropTypes.object,
    error: PropTypes.bool,
    id: PropTypes.number,
    pullLeft: PropTypes.bool,
};

export default connect()(CalendarWidget);


/** WEBPACK FOOTER **
 ** ./src/app/components/CalendarWidget.js
 **/